// lib/url.ts
// Zentrale Http(s)-URL-Guard-Funktion — verhindert javascript:/data: o. Ä. beim Öffnen
// externer Links aus Nutzerdaten (Dokument-URLs aus dem OneDrive/SharePoint-Sync,
// ⌘K-Suchtreffer, Recents aus localStorage). Vorher an drei Stellen dupliziert
// (lib/island/globalSearch.ts, components/island/deck/SearchPage.tsx,
// lib/kontakte/useKontaktVerknuepfungen.ts) — jetzt eine gemeinsame Quelle.
export function sichereHttpUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const u = new URL(url, window.location.origin);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.toString() : null;
  } catch { return null; }
}

export const istSichereHttpUrl = (u: string | null | undefined): boolean => !!sichereHttpUrl(u);
